var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_526_",
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_692_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE1C4"
    },
    d: "M257.751,109.599 c122.177,0,190.901,44.547,214.109,131.86c23.208,87.313-64.471,99.143-76.004,151.47c-11.533,52.327-113.109,86.812-202.51,63.056 C103.945,432.228,25.721,349.464,19.568,280.493C13.416,211.523,75.807,109.599,257.751,109.599z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    style: {
      fill: "#F7F7F7"
    },
    d: "M252.251,427.162c111.505,0,174.226-46.629,195.406-138.023 s-58.84-103.776-69.365-158.548c-10.525-54.772-103.229-90.869-184.821-66.002C111.88,89.456,40.488,176.088,34.873,248.282 C29.258,320.476,86.199,427.162,252.251,427.162z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_260_",
    d: "M252.251,427.162c111.505,0,174.226-46.629,195.406-138.023s-58.84-103.776-69.365-158.548 c-10.525-54.772-103.229-90.869-184.821-66.002C111.88,89.456,40.488,176.088,34.873,248.282 C29.258,320.476,86.199,427.162,252.251,427.162z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000073704839614819916420000011001432857856822972_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_260_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_338_",
    style: {
      opacity: 0.64,
      clipPath: "url(#XMLID_00000073704839614819916420000011001432857856822972_)",
      fill: "#E2E2E2"
    },
    d: " M26.979,250h16.696v23.709h16.028v-48.086H76.4v28.353h26.714v-38.37l15.695-15.695h21.705v29.719h20.703v-29.719h200.357v21.308 h20.703v-17.635h22.039v30.054h19.368v33.393l10.018,10.018v14.693h28.05c0,0,84.15,114.871-63.446,127.56 c-147.596,12.689-240.428,16.029-257.792,15.361c-17.364-0.668-70.793-21.371-70.793-21.371l-35.222-26.714 c0,0-14.199-22.707-18.206-28.718c-4.007-6.011,8.682-110.864,8.682-110.864"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_261_",
    style: {
      clipPath: "url(#XMLID_00000073704839614819916420000011001432857856822972_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_301_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_337_",
    style: {
      fill: "#262F38"
    },
    d: "M346.55,377.141H158.921c-6.593,0-11.938-5.345-11.938-11.938V256.44 c0-6.593,5.345-11.938,11.938-11.938H346.55c6.593,0,11.938,5.345,11.938,11.938v108.763 C358.488,371.796,353.143,377.141,346.55,377.141z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_336_",
    style: {
      fill: "#262F38"
    },
    points: "358.488,377.141 146.982,377.141 122.96,389.232 382.511,389.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_335_",
    style: {
      fill: "#999999"
    },
    points: "135.605,386.229 147.695,380.144 357.775,380.144 369.866,386.229  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_334_",
    style: {
      fill: "#1E262D"
    },
    d: "M372.23,400.457H133.24c-5.678,0-10.281-4.603-10.281-10.281v-0.944h259.551 v0.944C382.511,395.854,377.908,400.457,372.23,400.457z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_333_",
    x: 157.462,
    y: 255.711,
    style: {
      fill: "#CAE1C4"
    },
    width: 190.546,
    height: 110.219
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_302_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_332_",
    style: {
      fill: "#BABABA"
    },
    d: "M170.119,373.112V188.051c0-5.542,4.493-10.035,10.035-10.035h144.193 c5.542,0,10.035,4.493,10.035,10.035v185.061c0,5.542-4.493,10.035-10.035,10.035H180.154 C174.612,383.147,170.119,378.654,170.119,373.112z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_331_",
    x: 176.125,
    y: 184.021,
    style: {
      fill: "#DADADA"
    },
    width: 152.252,
    height: 193.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_330_",
    x: 214.791,
    y: 223.263,
    style: {
      fill: "#999999"
    },
    width: 75.888,
    height: 6.071
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_329_",
    x: 214.791,
    y: 260.226,
    style: {
      fill: "#999999"
    },
    width: 75.888,
    height: 6.071
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_328_",
    x: 214.791,
    y: 297.188,
    style: {
      fill: "#999999"
    },
    width: 75.888,
    height: 6.071
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_327_",
    x: 214.791,
    y: 334.151,
    style: {
      fill: "#999999"
    },
    width: 75.888,
    height: 6.071
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_326_",
    style: {
      fill: "#39AB68"
    },
    cx: 197.143,
    cy: 226.299,
    r: 10.702
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_324_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.351,231.083c-0.006,0-0.013,0-0.019,0c-0.559-0.006-1.091-0.248-1.462-0.665 l-3.607-4.055c-0.367-0.413-0.33-1.044,0.082-1.412c0.412-0.368,1.045-0.33,1.412,0.083l3.608,4.056l6.396-6.956 c0.375-0.406,1.007-0.429,1.413-0.056c0.405,0.375,0.431,1.008,0.056,1.414l-6.424,6.956 C197.432,230.852,196.902,231.083,196.351,231.083z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_319_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_322_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -128.3592 216.4868)",
    style: {
      fill: "#39AB68"
    },
    cx: 197.143,
    cy: 263.187,
    rx: 10.702,
    ry: 10.702
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_320_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.352,267.971c-0.007,0-0.013,0-0.02,0c-0.559-0.005-1.091-0.248-1.462-0.665 l-3.607-4.055c-0.367-0.413-0.33-1.045,0.082-1.412c0.412-0.368,1.045-0.33,1.412,0.082l3.608,4.056l6.396-6.955 c0.375-0.406,1.007-0.431,1.413-0.056c0.405,0.374,0.431,1.007,0.056,1.413l-6.424,6.955 C197.433,267.739,196.903,267.971,196.352,267.971z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_315_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_318_",
    style: {
      fill: "#39AB68"
    },
    cx: 197.143,
    cy: 300.075,
    r: 10.702
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_316_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.352,304.859c-0.007,0-0.013,0-0.02,0c-0.558-0.006-1.091-0.248-1.461-0.664 l-3.608-4.056c-0.367-0.413-0.33-1.045,0.082-1.412c0.412-0.369,1.045-0.33,1.412,0.082l3.608,4.056l6.396-6.956 c0.375-0.405,1.007-0.431,1.413-0.056c0.405,0.374,0.431,1.007,0.056,1.413l-6.424,6.956 C197.433,304.628,196.902,304.859,196.352,304.859z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_311_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_314_",
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -176.0999 451.4135)",
    style: {
      fill: "#39AB68"
    },
    cx: 197.143,
    cy: 336.963,
    rx: 10.702,
    ry: 10.702
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_312_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.351,341.747c-0.007,0-0.013,0-0.02,0c-0.559-0.006-1.091-0.248-1.461-0.665 l-3.607-4.055c-0.367-0.413-0.33-1.045,0.082-1.412c0.412-0.368,1.045-0.33,1.412,0.082l3.608,4.056l6.396-6.955 c0.375-0.405,1.007-0.43,1.413-0.056c0.405,0.374,0.431,1.007,0.056,1.413l-6.424,6.955 C197.432,341.516,196.902,341.747,196.351,341.747z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_306_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_310_",
    style: {
      fill: "#CAE1C4"
    },
    points: "342.5,300.611 332.497,292.07 320.773,300.611 320.773,235.158  342.5,235.158  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_309_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M336.418,204.906c1.557-9.829-11.12-9.829-9.563,0 c-1.557-9.829-13.613-5.912-9.095,2.955c-4.518-8.867-14.774-1.416-7.737,5.621c-7.037-7.037-14.488,3.219-5.621,7.737 c-8.867-4.518-12.784,7.538-2.955,9.095c-9.829-1.557-9.829,11.12,0,9.563c-9.829,1.557-5.912,13.613,2.955,9.095 c-8.867,4.518-1.416,14.774,5.621,7.737c-7.037,7.037,3.219,14.488,7.737,5.621c-4.518,8.867,7.538,12.785,9.095,2.955 c-1.557,9.829,11.12,9.829,9.563,0c1.557,9.829,13.613,5.912,9.095-2.955c4.518,8.867,14.774,1.416,7.737-5.621 c7.037,7.037,14.488-3.219,5.621-7.737c8.867,4.518,12.785-7.538,2.955-9.095c9.829,1.557,9.829-11.12,0-9.563 c9.829-1.557,5.912-13.613-2.955-9.095c8.867-4.518,1.416-14.774-5.621-7.737c7.037-7.037-3.219-14.488-7.737-5.621 C350.031,198.994,337.975,195.077,336.418,204.906z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_308_",
    style: {
      fill: "#CAE1C4"
    },
    cx: 331.636,
    cy: 235.096,
    r: 28.557
  }), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_307_",
    transform: "matrix(1 0 0 1 322.7393 231.9267)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'BebasNeue-Bold'",
      fontSize: "13.2389px",
      letterSpacing: 1
    }
  }, "iso"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.44,
    y: 15.887,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'BebasNeue-Bold'",
      fontSize: "13.2389px",
      letterSpacing: 1
    }
  }, "9100"))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M264.289,174.145c0-8.714-7.069-15.777-15.783-15.777 c-8.714,0-15.777,7.063-15.777,15.777h-18.059v16.197h67.677v-16.197H264.289z M248.506,182.246 c-4.468,0-8.096-3.627-8.096-8.102c0-4.468,3.627-8.096,8.096-8.096c4.474,0,8.101,3.627,8.101,8.096 C256.608,178.619,252.981,182.246,248.506,182.246z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_297_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E2E2"
    },
    d: "M122.393,143.436c5.647-0.252,11.24-1.428,15.068-5.026c2.077-1.952,4.228-3.706,4.228-6.453 c0-5.01,0.51-10.237,0.876-13.342c0.204-1.727,2.137-2.686,3.614-1.768c1.521,0.945,3.123,2.748,3.692,6.192 c0.328,1.986-0.686,13.852-0.686,13.852s19.457-0.836,20.773,2.924c1.317,3.76-5.914,5.206-5.914,5.206 s1.447,11.902-1.814,16.211c-6.478,8.559-25.664,6.027-39.837,5.755V143.436z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.725,
    y: 140.423,
    style: {
      fill: "#CAE1C4"
    },
    width: 9.732,
    height: 29.369
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E2E2"
    },
    d: "M127.826,164.753c0,1.234-1.001,2.235-2.235,2.235c-1.234,0-2.235-1.001-2.235-2.235 c0-1.234,1.001-2.235,2.235-2.235C126.825,162.518,127.826,163.519,127.826,164.753z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_280_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_296_",
    style: {
      fill: "#F3B8A5"
    },
    d: "M180.713,293.325c2.547-3.854,5.419-11.182,5.255-16.996 c-0.163-5.814,10.286-7.237,13.154-10.353c2.868-3.115,5.481-5.051,6.912-3.449s-5.387,9.461-8.217,10.539 c0,0,5.263,9.704,6.096,13.063s-3.469,9.928-5.07,10.095c-1.601,0.167-0.756-3.203-0.756-3.203s-6.364,9.613-11.19,9.223 C182.07,301.856,180.713,293.325,180.713,293.325z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_295_",
    style: {
      fill: "#DD938A"
    },
    d: "M182.459,290.216c5.894,4.201,12.904,6.372,12.904,6.372 s-2.613,3.414-4.572,4.452c-1.959,1.038-9.11-8.9-9.11-8.9L182.459,290.216z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_285_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_294_",
    style: {
      fill: "#F3B8A5"
    },
    points: "110.577,297.198 107.965,305.209 96.297,300.159 101.87,282.047  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_293_",
    style: {
      fill: "#DD938A"
    },
    d: "M109.804,299.568c-6.51-2.208-11.39-6.647-11.39-6.647l3.842-9.683 l8.996,12.441L109.804,299.568z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_292_",
    style: {
      fill: "#F3B8A5"
    },
    d: "M126.823,268.525c-0.079,6.778,7.084,17.132,7.084,17.132l-5.819,2.017 l-2.003,13.298c0,0-15.486-1.413-22.351-9.017c-6.864-7.605-1.022-23.339-1.022-23.339s4.513-5.666,5.767-5.808 c1.255-0.142,15.387,1.174,15.387,1.174L126.823,268.525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_291_",
    style: {
      fill: "#262F38"
    },
    d: "M132.87,266.3c-6.45,2.69-23.86,3.21-23.86,3.21l-2.44,14.98l-8.16,8.43 c-10.62-8.79-15.07-16.61-15.17-23.82c-0.03-2.04,0.16-3.98,0.59-5.82c1.48-6.62,5.85-11.88,13.34-15.02 c9.58-4,20.55-1.04,24.38,0c3.83,1.05-0.87-6.96-5.23-5.92c-4.35,1.05,5.58-8.02,15.5-0.09c4.16,3.33,6.15,7.61,6.58,11.68 C139,259.55,136.61,264.74,132.87,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_290_",
    style: {
      opacity: 0.72,
      fill: "#191E23"
    },
    d: "M132.87,266.3c-6.45,2.69-23.86,3.21-23.86,3.21l-2.44,14.98 l-8.16,8.43c-10.62-8.79-15.07-16.61-15.17-23.82c-0.03-2.04,0.16-3.98,0.59-5.82c-1.74,11.05,9.49,15.88,9.2,10.61 c-0.28-5.28,3.69-12.59,16.6-10.7c12.91,1.89,17.59-0.39,17.59-0.39s-7.09-0.94-3.4-3.92c3.49-2.81,9.51,2.75,14.58-4.95 C139,259.55,136.61,264.74,132.87,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_289_",
    style: {
      fill: "#F3B8A5"
    },
    d: "M108.313,280.132c-1.045-8.011-5.573-9.23-7.837-6.095 c-2.264,3.135-0.697,15.847,6.443,13.061C114.06,284.311,108.313,280.132,108.313,280.132z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M124.867,289.747c-2.671-0.013-4.635-1.902-4.635-1.902 s0.109,4.931,3.386,5.076L124.867,289.747z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    style: {
      fill: "#262F38"
    },
    d: "M123.862,274.49c0.289,1.28,0.973,2.216,1.527,2.091 c0.555-0.125,0.77-1.264,0.481-2.544c-0.289-1.28-0.973-2.216-1.527-2.091C123.789,272.071,123.573,273.21,123.862,274.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    style: {
      fill: "#DD938A"
    },
    d: "M105.756,280.581c-1.385-4.928-3.046-3.913-3.462-0.612 c-0.415,3.3,2.713,4.269,2.713,4.269L105.756,280.581z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M190.79,301.04c0,0-5.88,14.18-12.56,29.41c-0.01,0.01-0.02,0.03-0.02,0.04 c-6.68,15.23-14.15,31.49-17.35,35.75c-5.63,7.49-22.54-3.09-37.61-13.74c-2.1-1.49-4.17-2.97-6.16-4.41 c-1.17-0.84-2.31-1.7-3.43-2.58c-0.01,0-0.01,0-0.01,0c-14.51-11.34-24.67-24.83-24.67-24.83l-1.05-11.55l-0.2-2.14 c0.73-0.07,1.44-0.14,2.13-0.2c10.4-0.97,16.27-1.17,17.1,0.22c0.89,1.47,3.07,6.15,3.07,6.15s1.27,0.93,3.32,2.46 c7.4,5.51,24.97,18.81,29.47,24.09l38.411-48.008L190.79,301.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M113.35,315.62c0.05,1.67,0.41,14.62,0.31,29.89c0,0,0,0.01,0,0.02 c-0.09,12.58-0.49,26.75-1.64,37.48c-0.43,4.11-0.98,7.71-1.66,10.53c-4.76,19.79-61.97-21.34-61.97-21.34s1.47-4.18,4.05-10.55 c6.27-15.46,19.04-43.8,33.06-56.44c0,0,5.79-8.19,7.77-7.92c2.84,0.29,6.52,1.18,10.05,2.28c6.07,1.89,11.71,4.42,11.96,5.64 c0.38,1.93-1.93,10.23-1.93,10.23S113.35,315.5,113.35,315.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M113.66,345.53c-0.09,12.58-0.49,26.75-1.64,37.48 c-0.48,0.09-0.86,13.54-0.86,13.54S87.9,379.6,79.05,375.47c-8.84-4.13-22.1-10.32-26.61-13.82 c6.27-15.46,19.04-43.8,33.06-56.44c0,0,5.79-8.19,7.77-7.92c2.84,0.29,6.52,1.18,10.05,2.28c1.39,3.97-10.05-2.28-11.62,3.69 c-0.29,1.12-0.94,2.29-1.84,3.53c-0.56,0.76-1.21,1.54-1.93,2.34c-4.34,4.86-11.25,10.54-15.36,17.13 c-5.9,9.45-2.65,18.26,10.67,28.87c13.32,10.61,24.4,7.08,22.52-2.06c-1.89-9.14-14.33-18.57-13.44-22.62 c0.88-4.04,5.6,3.16,21.33,15.06C113.65,345.51,113.65,345.52,113.66,345.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_281_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M178.21,330.49c-6.68,15.23-14.15,31.49-17.35,35.75 c-5.63,7.49-22.54-3.09-37.61-13.74c-6.35-6.6-9.48-10.82-3-7.19c8.78,4.91,13.44,14.25,31.02,14.83 C168.84,360.73,167.48,349.26,178.21,330.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_262_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_279_",
    style: {
      fill: "#F7B313"
    },
    d: "M401.16,314.276c-2.59,5.17-25.84,18.64-23.25,10.15 c0.42-1.37,0.56-2.57,0.47-3.67c-0.48-5.73-7.45-8.75-16.9-18.66c-1.21-1.26-2.28-2.74-3.21-4.37 c-0.01-0.02-0.02-0.04-0.03-0.05c-7.79-13.59-6.27-38.03,5.09-44.24c0,0,27.31,4.74,30.85,7.09c3.53,2.34,7.71,18.32,7.71,18.32 S403.74,309.106,401.16,314.276z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    style: {
      fill: "#F47E14"
    },
    d: "M391.36,306.516c0,0-9.11,10.9-9.88,13.08c-0.23,0.67-1.48,1.01-3.1,1.16 c-0.48-5.73-7.45-8.75-16.9-18.66c-1.21-1.26-2.28-2.74-3.21-4.37c3.49,5.85,15.98,14.44,16.8,11.68 c0.83-2.76-5.93-3.72-5.31-5.65c0.62-1.94,9.18,0.13-0.04-5.81s-15.34-30.12-8.56-38.99l15.57,5.07l13.97,22.55L391.36,306.516z "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_277_",
    style: {
      fill: "#F3B8A5"
    },
    points: "378.732,291.354 382.508,302.935 394.176,297.885 388.603,279.774  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_276_",
    style: {
      fill: "#DD938A"
    },
    d: "M389.687,282.913c-0.639,5.794-8.95,14.592-8.95,14.592l-1.425-4.371 l6.615-10.222l2.48-3.896L389.687,282.913z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_275_",
    style: {
      fill: "#F3B8A5"
    },
    d: "M363.65,266.251c0.079,6.778-7.084,17.132-7.084,17.132l5.819,2.018 l2.167,14.383c0,0,14.051-4.07,20.915-11.674c6.864-7.605,2.294-21.767,2.294-21.767s-4.513-5.666-5.767-5.808 c-1.255-0.142-15.387,1.174-15.387,1.174L363.65,266.251z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_274_",
    style: {
      fill: "#262F38"
    },
    d: "M366.611,272.217c-0.289,1.28-0.973,2.216-1.527,2.091 c-0.555-0.125-0.77-1.264-0.481-2.544c0.289-1.28,0.973-2.216,1.527-2.091C366.684,269.797,366.9,270.937,366.611,272.217z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_273_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M366.465,287.89c4.244-1.845,6.444-6.09,6.444-6.09s1.491,7.667-4.967,9.554 L366.465,287.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_272_",
    style: {
      fill: "#F3B8A5"
    },
    d: "M307.867,325.725c-4-2.312-9.841-7.587-12.29-12.863 c-2.449-5.275-12.435-1.884-16.392-3.391c-3.957-1.507-7.16-2.073-7.725,0c-0.565,2.073,9.044,6.061,12.058,5.762 c0,0-0.377,11.033,0.377,14.411c0.754,3.378,7.536,7.335,9.044,6.769c1.507-0.565-0.754-3.203-0.754-3.203 s9.986,5.761,14.131,3.257C310.461,333.965,307.867,325.725,307.867,325.725z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_271_",
    style: {
      fill: "#DD938A"
    },
    d: "M304.645,323.514c-2.192,7.811-7.055,12.223-7.055,12.223 s2.084,1.676,6.32,1.147c4.236-0.529,2.565-11.786,2.565-11.786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M402.17,309.246c0,0-3.58,19.28-12.92,37.08c-4.51,8.6-9.68,18.35-14.91,25.6 c-0.16,0.25-0.34,0.49-0.52,0.72c-5.41,7.34-10.86,11.86-15.64,9.47c-5.8-2.9-25.19-18.89-39.51-30.99l-0.66-0.56l-0.01-0.01 c-8.92-7.54-15.71-13.43-15.71-13.43l4.18-12.03l56.01,25.22c2.14-8.6,17.49-38.4,17.49-38.4s-0.13-5.16,0-6.88 c0.14-1.72,6.19-4.37,17.2-8.6L402.17,309.246z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_269_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M373.82,372.646c-5.41,7.34-10.86,11.86-15.64,9.47 c-5.8-2.9-25.19-18.89-39.51-30.99l-0.66-0.56c0.44,0.25,14.59,8.5,26.32,18.18C355.87,378.266,368.22,379.926,373.82,372.646z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_268_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M445.54,376.116l-37.69,22.07c0,0-23.96,10.01-24.65,5.24 c-0.46-3.24-2.24-22.87-3.41-40.99c-0.56-8.59-0.98-16.84-1.06-22.84l18.44-43.16c0,0,3.27-0.88,8.72,6.5 c0.93,1.26,2.71,4.24,5.01,8.3C422.05,330.916,445.54,376.116,445.54,376.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_267_",
    style: {
      fill: "#CAE1C4"
    },
    d: "M445.54,376.116l-37.69,22.07c0,0-23.96,10.01-24.65,5.24 c-0.46-3.24-2.24-22.87-3.41-40.99c8.74-10.37,14.72-25.17,17.38-22.84c2.76,2.42-7.89,23.9-12.25,29 c-4.35,5.09-2.13,14.07,9.26,2.19c11.38-11.88,23.26-21.1,23.89-31.19c0.62-10.08-21.58-4.44-25.95-11.64 c-3.17-5.21,9.91-12.74,18.78-16.72C422.05,330.916,445.54,376.116,445.54,376.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_266_",
    style: {
      fill: "#F7B313"
    },
    d: "M429.07,316.536c-8.67,17.71-29.15,13.84-37.98,9.22 c-5.29-2.76-8.35-8.11-8.55-13.81c-0.15-3.82,1-7.8,3.62-11.28c6.55-8.68,4.16-26.95-2.79-26.84c-0.91,0.02-1.91,0.05-2.98,0.07 c-7.17,0.11-17.27-0.69-19.39-15.94c-0.81-5.81,5.74-16.48,23.6-18.74c13.48-1.71,25.69,7.94,28.04,18.01c0,0.01,0,0.01,0,0.01 c0.2,0.82,0.32,1.64,0.38,2.46c0.74,10.89-9.78,18.82,0.74,21.54C424.27,283.966,437.74,298.816,429.07,316.536z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_265_",
    style: {
      fill: "#F3B8A5"
    },
    d: "M379.608,276.06c1.045-8.011,5.573-9.23,7.837-6.095 c2.264,3.135,0.697,15.847-6.443,13.061C373.861,280.239,379.608,276.06,379.608,276.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_264_",
    style: {
      fill: "#DD938A"
    },
    d: "M381.484,275.224c0.641-3.096,3.096-3.096,3.417-1.174 c0.32,1.922-2.776,5.724-2.776,5.724L381.484,275.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_263_",
    style: {
      fill: "#F47E14"
    },
    d: "M429.07,316.536c-8.67,17.71-29.15,13.84-37.98,9.22 c-5.29-2.76-8.35-8.11-8.55-13.81c4.63,7.72,22.79,11.32,24.14,8.81c1.56-2.89-12.91-4.23-11.13-9.52 c1.78-5.29,22.7,7.07,27.6-2.69c4.9-9.76,2.41-19.55-7.12-21.97c-9.53-2.41-13.8,1.01-13.5-4.78 c0.31-5.78,9.71-11.35,10.49-22.1c0.74,10.89-9.78,18.82,0.74,21.54C424.27,283.966,437.74,298.816,429.07,316.536z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_258_",
    style: {
      fill: "#F7B313"
    },
    points: "292.544,150.49 283.401,155.296 285.147,145.115 277.75,137.905  287.972,136.42 292.544,127.157 297.115,136.42 307.337,137.905 299.941,145.115 301.687,155.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_257_",
    style: {
      fill: "#F7B313"
    },
    points: "213.85,150.49 204.706,155.296 206.453,145.115 199.056,137.905  209.278,136.42 213.85,127.157 218.421,136.42 228.643,137.905 221.246,145.115 222.992,155.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_256_",
    style: {
      fill: "#F7B313"
    },
    points: "251.059,134.889 244.12,138.537 245.445,130.811 239.832,125.339  247.589,124.212 251.059,117.182 254.528,124.212 262.286,125.339 256.672,130.811 257.997,138.537  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_690_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE1C4"
    },
    d: "M55.426,77.441 c3.066,0,5.935,0.965,8.363,2.645c2.613-4.376,7.392-7.302,12.86-7.302c7.596,0,13.87,5.654,14.847,12.982 c2.556,0.096,4.913,0.952,6.861,2.351c0.952-0.23,1.942-0.351,2.964-0.351c4.606,0,8.65,2.466,10.867,6.146h-9.346H90.454h-0.147 H79.153h-7.954H62.99H39.659C40.093,84.73,46.993,77.441,55.426,77.441z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_694_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE1C4"
    },
    d: "M408.372,96.938 c3.066,0,5.935,0.965,8.362,2.645c2.613-4.376,7.392-7.302,12.86-7.302c7.596,0,13.87,5.654,14.847,12.982 c2.555,0.096,4.913,0.952,6.861,2.351c0.952-0.23,1.942-0.351,2.964-0.351c4.606,0,8.65,2.466,10.867,6.146h-9.346h-12.388h-0.147 h-11.154h-7.954h-8.209h-23.331C393.04,104.227,399.939,96.938,408.372,96.938z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_696_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE1C4"
    },
    cx: 78.097,
    cy: 416.88,
    r: 9.089
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_698_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#CAE1C4",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 55.774,
    cy: 131.702,
    r: 9.089
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_702_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#CAE1C4",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 389.965,
    y1: 45.007,
    x2: 370.685,
    y2: 78.119
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_704_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#CAE1C4",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 115.464,
    y1: 50.49,
    x2: 134.508,
    y2: 70.378
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_706_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#CAE1C4",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 147.356,
    y1: 45.007,
    x2: 155.698,
    y2: 60.434
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongTerm);
export default __webpack_public_path__ + "static/media/LongTerm.8b7aeac14b4b4c1f4bd1822556404888.svg";
export { ForwardRef as ReactComponent };